







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class StyledSelectDefaultView extends Vue {
  @Prop({required: true})
  private displayString!: string;

  @Prop({required: false, default: false})
  private isDisplayComponent!: boolean;
}
